import React from "react";
import "./taload.css";
import "../Dashboard/Dashboard.css";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useNavigate } from "react-router-dom";

export const Claimdetail = () => {
  const responseobject = useSelector(
    (state) => state.getclaimdatareducer?.getclaimdata
  );
  const navigate = useNavigate();
  const goback = () => {
    navigate("/taload");
  };
  const toTareq = () => {
    navigate("/ta-load-request");
  };
  return (
    <React.Fragment>
    

      <div class="mid">
        <div class="container-fluid">
          <div class="head">
            <h3>Claim Details</h3>
            <button class="btn" type="button" onClick={goback}>
              Back
            </button>
            <button className="btn" type="button" onClick={toTareq}>
              Ta Load Request List
            </button>
          </div>

          <div class="loaddtl">
            <h4>Thank you, details have been submited successfully!</h4>

            <div class="bankcard">
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <tbody className="Thankyou_table">
                    <tr>
                      <td width="160">TA Load Amount:</td>
                      <td>{`₹${responseobject.amount}`}</td>
                    </tr>
                    <tr>
                      <td>Bank Name:</td>
                      <td>{responseobject.bank}</td>
                    </tr>
                    <tr>
                      <td>Transaction ID:</td>
                      <td>{responseobject.utr}</td>
                    </tr>
                    <tr>
                      <td>Date:</td>
                      <td>{responseobject.txnDate}</td>
                    </tr>
                    <tr>
                      <td>Transaction Mode:</td>
                      <td>{responseobject.txnMode}</td>
                    </tr>
                    <tr>
                      <td>Request ID:</td>
                      <td>{responseobject.refId}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="txn-btn">
                <button type="button" class="help"></button>
              </div>
            </div>
          </div>
        </div>
      </div>

     
    </React.Fragment>
  );
};

export default Claimdetail;
